//@ts-nocheck
import React, { useEffect, useState } from "react";
import { CURRENT_TENANT } from "../../../../constants/Constants";
import MDBox from "components/MDBox";
import {
  Checkbox,
  TextField,
  FormControlLabel,
  Box,
  Chip,
  Autocomplete,
  Popper,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const MeetingForm = ({
  dealApplicationStore,
  merchantStore,
  offerDetailsFormStore,
  applicationId,
  onSubmit,
  meeting,
  closeModal,
  recipientsByCategory,
}) => {
  const [form, setForm] = useState({
    recipients: "",
    description: offerDetailsFormStore
      ? offerDetailsFormStore?.contractTerms?.funder?.name +
        " & " +
        merchantStore.merchantName +
        " Funding Call (" +
        dealApplicationStore.applicationNo +
        ")"
      : "",
    startDate: "",
    startTime: "",
    duration: "30",
    password: Math.random().toString(36).substring(2, 8).toUpperCase(),
    agenda: "",
    finalEmailRecipients: [],
  });

  const CustomPopper = (props: any) => {
    return (
      <Popper
        {...props}
        placement="bottom-end"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              rootBoundary: "document",
            },
          },
          {
            name: "flip",
            enabled: false,
          },
        ]}
      />
    );
  };

  const [checkboxes, setCheckboxes] = useState([
    {
      id: "funders",
      value: "Funder",
      checked: false,
    },
    {
      id: "merchantOwners",
      value: "Merchant Owner(s)",
      checked: false,
    },
    {
      id: "salesrep",
      value: "Representative",
      checked: false,
    },
    {
      id: "isobroker",
      value: "ISO/Broker",
      checked: false,
    },
  ]);

  const [newEmail, setNewEmail] = useState("");
  const [dropDownSelectedUsers, setDropdownSelectedUsers] = useState([]);
  const currentTenant = localStorage.getItem(CURRENT_TENANT);

  useEffect(() => {
    let recipient = [];

    if (meeting && meeting.recipientList) {
      recipient = meeting.recipientList.map((v) => ({
        name: "",
        email: v,
      }));
    }
    if (!meeting) return;

    let updatedDescription = meeting.description;
    const lastIndex = meeting.description.lastIndexOf(":");
    if (lastIndex !== -1) {
      updatedDescription = meeting.description.substring(0, lastIndex);
    }

    setForm((prevForm) => ({
      description: updatedDescription,
      startDate: meeting.startDate,
      startTime: meeting.startTime,
      duration: meeting.duration,
      password: meeting.password,
      finalEmailRecipients: recipient,
    }));
  }, [meeting]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckBoxChange = (index) => {
    const updatedCheckboxes = [...checkboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
    setCheckboxes(updatedCheckboxes);
    populateEmailSenders(updatedCheckboxes[index].id, updatedCheckboxes[index].checked);
  };

  const populateEmailSenders = (id, isChecked) => {
    let recipients = [];
    let recipientsRemoved = [];

    const addedUsers = recipientsByCategory[id] ? recipientsByCategory[id] : [];
    // const addedUsers = recipientsByCategory[id];

    if (addedUsers) {
      if (isChecked) {
        recipients = addedUsers.filter((user) => user.email);
      } else {
        recipientsRemoved = addedUsers.filter((user) => user.email);
      }
    }

    setForm((prevForm) => ({
      ...prevForm,
      finalEmailRecipients: (() => {
        const mergedList = isChecked
          ? [...(prevForm.finalEmailRecipients || []), ...(recipients || [])]
          : (prevForm.finalEmailRecipients || []).filter(
              (recipient) =>
                !(recipientsRemoved || []).some(
                  (removedUser) => removedUser.email === recipient.email
                )
            );
        const uniqueSet = new Set(mergedList.map((user) => JSON.stringify(user)));
        return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
      })(),
    }));
  };

  const handleAddEmail = () => {
    const isAddable = !form.finalEmailRecipients.some(
      (recipient) => recipient.email === newEmail.trim()
    );
    if (isValidEmail(newEmail) && isAddable) {
      setForm((prevForm) => ({
        ...prevForm,
        finalEmailRecipients: (() => {
          const mergedList = [
            ...prevForm.finalEmailRecipients,
            { name: "", email: newEmail.trim() },
          ];
          const uniqueSet = new Set(mergedList.map((user) => JSON.stringify(user)));
          return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
        })(),
      }));
      setNewEmail("");
    } else {
      alert("Please enter a valid unique email");
    }
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleRemoveUser = (indexToRemove) => {
    setForm((prevForm) => ({
      ...prevForm,
      finalEmailRecipients: prevForm.finalEmailRecipients.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedDescription = `${form.description}`;
    const updatedForm = { ...form, description: updatedDescription };
    onSubmit(updatedForm);
    closeModal();
  };

  const reset = () => {
    closeModal();
  };

  const customOptions = (
    recipientsByCategory && recipientsByCategory.users ? recipientsByCategory.users : []
  )
    .filter((usr) => usr.email)
    .map((usr) => ({
      label: `${usr.name} (${usr.email})`,
      value: usr,
      isSelected: dropDownSelectedUsers.some((selected) => selected.value.email === usr.email),
    }));

  const OnChangeSelectedUser = (selectedUsers) => {
    const filteredList = selectedUsers.filter((user) => {
      const email = user && user.value && user.value.email;
      return (
        form.finalEmailRecipients &&
        !form.finalEmailRecipients.some((recipient) => recipient.email === email)
      );
    });

    setDropdownSelectedUsers(filteredList);

    const newRecipients = filteredList.map((user) => user.value);
    setForm((prevForm) => ({
      ...prevForm,
      finalEmailRecipients: (() => {
        const mergedList = (prevForm.finalEmailRecipients || []).concat(newRecipients || []);
        const uniqueSet = new Set(mergedList.map((user) => JSON.stringify(user)));
        return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
      })(),
    }));

    // Remove unchecked users from finalEmailRecipients
    const removedUsers = dropDownSelectedUsers.filter(
      (user) => !selectedUsers.some((selected) => selected.value.email === user.value.email)
    );
    setForm((prevForm) => ({
      ...prevForm,
      finalEmailRecipients: prevForm.finalEmailRecipients.filter(
        (recipient) =>
          !removedUsers.some((removedUser) => removedUser.value.email === recipient.email)
      ),
    }));
  };

  const renderOption = (option) => {
    const optionStyle = {
      display: "flex",
      alignItems: "center",
      height: "30px",
    };

    return (
      <div style={optionStyle}>
        <Checkbox
          checked={option.isSelected}
          onChange={() => {
            const updatedSelectedUsers = option.isSelected
              ? dropDownSelectedUsers.filter((user) => user.value.email !== option.value.email)
              : [...dropDownSelectedUsers, option];
            OnChangeSelectedUser(updatedSelectedUsers);

            if (option.isSelected) {
              setForm((prevForm) => ({
                ...prevForm,
                finalEmailRecipients: prevForm.finalEmailRecipients.filter(
                  (recipient) => recipient.email !== option.value.email
                ),
              }));
            }
          }}
          color="primary"
        />
        <Typography style={{ fontSize: 14 }}>{option.label}</Typography>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit} className="MeetingForm">
      <div className="form-group">
        <Typography className="decline-modal-subheader" variant="headline">
          MEETING PARTICIPANTS
        </Typography>
      </div>
      <div className="checkbox-container">
        {checkboxes.map((checkbox, index) => (
          <div key={index} className="mb-2">
            <input
              type="checkbox"
              className="me-2"
              checked={checkbox.checked}
              onChange={() => handleCheckBoxChange(index)}
            />
            <span>{checkbox.value}</span>
          </div>
        ))}
      </div>
      <div
        className="email-main-container"
        style={{
          marginBottom: "8px",
        }}
      >
        <MDBox sx={{ mt: 2 }}>
          <MDTypography variant="subtitle2" fontWeight={"bold"} sx={{ marginBottom: 1 }}>
            Add Recipients
          </MDTypography>
          <Autocomplete
            multiple
            disableCloseOnSelect={true}
            id="search-users"
            options={customOptions}
            getOptionLabel={(option) => `${option.label}`}
            value={dropDownSelectedUsers}
            onChange={(e, newValue) => setDropdownSelectedUsers(newValue as User[])}
            renderInput={(params) => <TextField {...params} label="Search Users" />}
            renderTags={(value, getTagProps) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {value.map((user, index) => (
                  <Chip
                    key={user?.value?.email}
                    label={`${user?.value?.name} (${user?.value?.email})`}
                    {...getTagProps({ index })}
                  />
                ))}
              </Box>
            )}
            PopperComponent={CustomPopper}
          />
        </MDBox>

        <div className="mb-2 add-email-container" style={{ marginTop: "15px", color: "#575656" }}>
          <span>Add Email Address</span>
          <input
            type="email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            style={{ height: "30px" }}
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            title="Please enter a valid email address"
          />
          <MDButton onClick={handleAddEmail}>ADD </MDButton>
        </div>
      </div>

      <MDBox sx={{ mt: 2 }}>
        <MDBox
          sx={{ minHeight: 80, maxHeight: 200, overflow: "auto" }}
          border={1}
          borderColor={"gray"}
        >
          {form?.finalEmailRecipients?.map((recipient, index) => (
            <Chip
              key={index}
              label={`${recipient.name} (${recipient.email})`}
              onDelete={() => handleRemoveUser(index)}
              sx={{ m: 0.5 }}
            />
          ))}
          {dropDownSelectedUsers.map((user, index) => (
            <Chip
              key={index}
              label={`${user?.value?.name} (${user?.value?.email})`}
              onDelete={() => handleRemoveDropDownUser(index)}
              sx={{ m: 0.5 }}
            />
          ))}
        </MDBox>
      </MDBox>

      <MDBox style={{ marginTop: 20 }}>
        <MDInput
          fullWidth
          label={"Meeting Title"}
          type="text"
          name="description"
          value={form.description}
          onChange={handleChange}
          className="form-control"
          required
        />
      </MDBox>

      <MDBox marginTop={1} display={"flex"} gap={3}>
        <MDInput
          type="date"
          name="startDate"
          value={form.startDate}
          onChange={handleChange}
          className="form-control"
          required
        />

        <MDInput
          type="time"
          name="startTime"
          value={form.startTime}
          onChange={handleChange}
          className="form-control"
          required
        />
      </MDBox>

      <MDBox style={{ marginTop: 20 }}>
        <MDInput
          fullWidth
          label={"Duration (Minutes)"}
          type="number"
          name="duration"
          value={form.duration}
          onChange={handleChange}
          className="form-control"
          required
        />
      </MDBox>

      <MDBox style={{ marginTop: 20 }}>
        <MDInput
          label="Password"
          type="text"
          name="password"
          value={form.password}
          onChange={handleChange}
          className="form-control"
          required
        />
      </MDBox>

      <div className="submit-button" style={{ display: "flex", justifyContent: "flex-end" }}>
        <MDButton
          type="reset"
          className="btn-simple btn btn-default"
          onClick={reset}
          style={{ marginRight: "20px" }}
        >
          Cancel
        </MDButton>
        .
        <MDButton
          type="submit"
          style={{ backgroundColor: "#2F929F", color: "white", border: "none" }}
          className="pull-right btn btn-default"
        >
          {meeting ? "Update Meeting" : "Schedule Meeting"}
        </MDButton>
      </div>
    </form>
  );
};

export default MeetingForm;
